import { render, staticRenderFns } from "./aiGenerateTaskModal.vue?vue&type=template&id=2b47cb4a&scoped=true&"
import script from "./aiGenerateTaskModal.vue?vue&type=script&lang=js&"
export * from "./aiGenerateTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./aiGenerateTaskModal.vue?vue&type=style&index=0&id=2b47cb4a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47cb4a",
  null
  
)

export default component.exports